import {
  useContext,
  useEffect,
  useState,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { TransactionalSubheader } from "iuvity-ui-components/dist/transactionalsubheader";
import { BoxFull } from "iuvity-ui-components/dist/boxfull";
import { Header } from "../../components";
import { getGlobalConfigurationPageLabel } from "../../utils";
import { AppContext } from "../../context/index";
import { useUsers } from "../../hooks/useUsers";
import { UserAdminComponent } from "../../components/users/UserAdminComponent";
import { TabView } from "iuvity-ui-components";
import { getOtpParams } from "../../services/iam/getOtpParams";

export const AdminUsersPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    t,
    appState: { user, activeIndexCatalogue },
    setAppState,
  } = useContext(AppContext);

  const { data, userAction, reloadFn } = useUsers("DATA");
  const [enableOtp, setEnableOtp] = useState<boolean>(false);

  const customPageLabel = getGlobalConfigurationPageLabel(t, location.pathname);
  const [activeIndex, setActiveIndex] = useState<number>(activeIndexCatalogue || 0);

  useEffect(() => {
    const getOtpConfig = async () => {
      try {
        const data = await getOtpParams();
        const enableOtp = data.data.otp;
        setEnableOtp(enableOtp === 'true');
      }
      catch (e) { console.log('GET OTP CONFIG:', { error: e }) }
    }
    getOtpConfig();
  }, [])



  return (
    <>
      {/* <Header
        welcomeMessage={t("Dashboard.welcomeTitle")}
        userName={user?.name}
      /> */}
      <TransactionalSubheader
        subheaderTitle={
          <div>
            {t("Users.usersTitle")}
          </div>
        }
      >
        <TransactionalSubheader.BreadCrumb
          id={customPageLabel}
          disabledDefaultHome={true}
          breadcrumbsHomeItem={{
            icon: "iu iu-icon-home",
            command: () => {
              navigate("/");
            },
          }}
          breadcrumbsItems={[
            {
              label: t("Users.usersBreadcrum"),
              style: { fontWeight: "bold" },
              disabled: true
            },
            {
              label: t("Users.usersTitle"),
              style: { fontWeight: "bold" },
              disabled: true
            },
          ]}
        />
        <TransactionalSubheader.Title />
        <div className="t-subheader-content">
          <span>{t("Users.usersDescription")}</span>
        </div>
      </TransactionalSubheader>


      <BoxFull className="px-5 py-0" style={{ marginTop: "40px" }} variant="tertiary">
        <TabView
          className="upload-tabview "
          activeIndex={activeIndex}
          onTabChange={(e) => {
            setActiveIndex(e.index);
            setAppState((prev) => ({
              ...prev,
              activeIndexPoints: e.index,
            }));
          }}
          items={[
            {
              key: "1",
              header: t("Users.availableTabTitle"),
              children:
                <UserAdminComponent
                  data={data}
                  userAction={userAction}
                  reloadFn={reloadFn}
                  enableOtp={enableOtp}
                />,
            },
            {
              key: "2",
              header: t("Users.deletedTabTitle"),
              children:
                <UserAdminComponent
                  data={data}
                  userAction={userAction}
                  reloadFn={reloadFn}
                  isDeleteComponent
                />,
            },
          ]}
        />
      </BoxFull>
    </>
  );
};
